/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  Grid,
  Icon,
  Link,
  Option,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Space,
  Switch,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { EditIcon, InfoOIcon } from '@tonic-one/react-icons';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  CheckboxTitle,
  FormInput,
  FormLabel,
  FormTextarea,
  TitleLabel,
} from 'src/components/Common/FormComponent';
import { Info } from 'src/components/Common/Info';
import {
  ActionEnum,
  ExchangeOnlinePolicyItem,
  SpamLevelEnum,
} from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import EditNotificationModal from './EditNotificationModal';
import { useAntiSpamRuleStyle } from './style';
import i18next from 'i18next';
import { PolicyModeEnum, PolicyTypeEnum } from '@Policy/utils/constants';
import ApplyBound from '../../Components/ApplyBound';
import { CAS_DOC_LINK, getCasOLHLink } from '@Utils/casDocLink';
import { actionTranslateMap } from '@Policy/AdvancedThreatProtection/PolicyTemplate/Components/shared';
import RedirectLink from '@Components/RedirectLink';
import RetroScanEnableModal from '@Policy/AdvancedThreatProtection/PolicyTemplate/Components/RetroScanEnableModal';
import { PolicySubTypeEnum } from '@Types/index';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';
import { usePermissionStore } from '@Models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';
export const AsRuleStatus = () => {
  const { t } = useTranslation();
  const { descriptionColor, titleColor } = useAntiSpamRuleStyle();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const asEnabled = policySelector((s) => s.tmAntispamfilters.asEnabled);
  const asEnabledFeedback = policySelector(
    (s) => s.tmAntispamfilters.asEnabledFeedback
  );
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  useWhyDidYouUpdate('AsRuleStatus', { asEnabled, asEnabledFeedback });
  return (
    <>
      <Flex alignItems="center" pt="8px" pb="16px">
        <Switch
          mr="1x"
          checked={!!asEnabled}
          value={asEnabled}
          onChange={() => {
            // setAsEnabled();
            setAsState({ asEnabled: asEnabled === 1 ? 0 : 1 });
          }}
        />
        <Text mr="8px" fontSize="18px" lineHeight="24px" color={titleColor}>
          {t('policy.label.antiSpam')}
        </Text>
      </Flex>
      <Flex>
        <Checkbox
          checked={!!asEnabledFeedback}
          onChange={() => {
            // setAsEnabledFeedback();
            setAsState({
              asEnabledFeedback: asEnabledFeedback === 1 ? 0 : 1,
            });
          }}
        >
          <Text color={descriptionColor}>
            {t('policy.label.enableAntiSpamFeedback')}
          </Text>
        </Checkbox>
      </Flex>
      <Box pt="12px" pb="12px" whiteSpace="pre-wrap" color={descriptionColor}>
        <Trans i18nKey="policy.additionalInfo">
          placeholder
          <Link
            href={getCasOLHLink(
              CAS_DOC_LINK.policy.atp.advancedSpamProtection,
              i18next.language
            )}
            target="_blank"
          >
            placeholder
          </Link>
        </Trans>
      </Box>
    </>
  );
};
export const AsApplyBound = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const asApplyBound = policySelector((s) => s.tmAntispamfilters.asApplyBound);
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  useWhyDidYouUpdate('AsApplyBound', { asApplyBound });
  return (
    <ApplyBound
      applyBoundValue={asApplyBound}
      setApplyBound={setAsState}
      applyBoundKey="asApplyBound"
    />
  );
};
export const AsDetectionLevel = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const asSpamLevel = policySelector((s) => s.tmAntispamfilters.asSpamLevel);
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  useWhyDidYouUpdate('AsDetectionLevel', { asSpamLevel });
  return (
    <Flex mt="23px" alignItems="flex-start">
      <FormLabel label={t('policy.detectionLevel.title')} width="200px" />
      <RadioGroup
        value={asSpamLevel}
        onChange={(value: SpamLevelEnum) => {
          // setAsSpamLevel(value);
          setAsState({ asSpamLevel: Number(value) });
        }}
      >
        <Stack spacing="1x" shouldWrapChildren>
          <Radio value={SpamLevelEnum.high}>
            <CheckboxTitle
              title={t('policy.detectionLevel.high')}
              subTitle={t('policy.detectionLevel.highDesc')}
            />
          </Radio>
          <Radio value={SpamLevelEnum.medium}>
            <CheckboxTitle
              title={t('policy.detectionLevel.medium')}
              subTitle={t('policy.detectionLevel.mediumDesc')}
            />
          </Radio>
          <Radio value={SpamLevelEnum.low}>
            <CheckboxTitle
              title={t('policy.detectionLevel.low')}
              subTitle={t('policy.detectionLevel.lowDesc')}
            />
          </Radio>
        </Stack>
      </RadioGroup>
    </Flex>
  );
};
export const AsBec = () => {
  const { t } = useTranslation();
  const { descriptionColor } = useAntiSpamRuleStyle();
  return (
    <Flex direction="column" mt="24px">
      <Text fontSize="16px" lineHeight="22px" mb="12px">
        {t('policy.antiSpam.EnhancedBEC')}
      </Text>
      <Flex height="32px" alignItems="center" whiteSpace="pre-wrap">
        <Trans
          i18nKey="policy.antiSpam.EnhancedBECInfo"
          color={descriptionColor}
        >
          placeholder
          <RedirectLink
            href={`policy/global-settings/high-profile-list`}
            target="_blank"
          >
            placeholder
          </RedirectLink>
          placeholder
          <RedirectLink
            href={`policy/global-settings/internal-domain-list`}
            target="_blank"
          >
            placeholder
          </RedirectLink>
        </Trans>
      </Flex>
    </Flex>
  );
};
export const AsSuspiciousDetection = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const asAggressiveHpuEnabled = policySelector(
    (s) => s.tmAntispamfilters.asAggressiveHpuEnabled
  );
  const asAggressiveNameSpoofingEnabled = policySelector(
    (s) => s.tmAntispamfilters.asAggressiveNameSpoofingEnabled
  );
  const asNewbornDetectionEnabled = policySelector(
    (s) => s.tmAntispamfilters.asNewbornDetectionEnabled
  );
  const asUnusualSignalEnabled = policySelector(
    (s) => s.tmAntispamfilters.asUnusualSignalEnabled
  );
  const aggressiveNameSpoofing = contextSelector(
    (s) => s.config.featureShow.aggressiveNameSpoofing
  );
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  useWhyDidYouUpdate('AsSuspiciousDetection', {
    asAggressiveHpuEnabled,
    asAggressiveNameSpoofingEnabled,
    asNewbornDetectionEnabled,
    aggressiveNameSpoofing,
    asUnusualSignalEnabled,
  });
  return (
    <Flex direction="column" mt="24px">
      <Text fontSize="16px" lineHeight="22px">
        {t('policy.label.suspiciousDetection')}
        <Space width="1x"></Space>
        <Info content={t('policy.suspiciousDetection.desc')} />
      </Text>
      <Text fontSize="14px" lineHeight="20px" fontWeight="600" mt="10px">
        {t('policy.label.suspiciousSender')}
      </Text>
      <Text color={colorStyle.color.secondary} mt="10px">
        {t('policy.suspiciousSender.desc')}
      </Text>
      <Stack
        direction="column"
        mt="10px"
        mb="10px"
        spacing="1x"
        pl="40px"
        shouldWrapChildren
      >
        <Flex height="32px" alignItems="center">
          <Checkbox
            checked={!!asAggressiveHpuEnabled}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              console.log('asAggressiveHpuEnabled:', e.target.checked);
              setAsState({
                asAggressiveHpuEnabled: e.target.checked ? 1 : 0,
              });
            }}
            children={t(
              'policy.antiSpam.checkBoxForSpoofingDetection.highProfileUsers'
            )}
          />
        </Flex>
        {aggressiveNameSpoofing ? (
          <Flex height="32px" alignItems="center">
            <Checkbox
              checked={!!asAggressiveNameSpoofingEnabled}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                console.log(
                  'asAggressiveNameSpoofingEnabled:',
                  e.target.checked
                );
                setAsState({
                  asAggressiveNameSpoofingEnabled: e.target.checked ? 1 : 0,
                });
              }}
              children={t(
                'policy.antiSpam.checkBoxForSpoofingDetection.anyUsers'
              )}
            />
          </Flex>
        ) : null}
        <Flex height="32px" alignItems="center">
          <Checkbox
            checked={!!asNewbornDetectionEnabled}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              console.log('asNewbornDetectionEnabled:', e.target.checked);
              setAsState({
                asNewbornDetectionEnabled: e.target.checked ? 1 : 0,
              });
            }}
            children={t(
              'policy.antiSpam.checkBoxForSpoofingDetection.newBornUsers'
            )}
          />
        </Flex>
      </Stack>
      <Text fontSize="14px" lineHeight="20px" fontWeight="600" mt="10px">
        {t('policy.label.suspiciousContent')}
      </Text>
      <Stack
        direction="column"
        mt="10px"
        spacing="1x"
        pl="40px"
        shouldWrapChildren
      >
        <Flex height="32px" alignItems="center">
          <Checkbox
            mr={8}
            checked={!!asUnusualSignalEnabled}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              console.log('asUnusualSignalEnabled:', e.target.checked);
              setAsState({
                asUnusualSignalEnabled: e.target.checked ? 1 : 0,
              });
            }}
            children={t(
              'policy.antiSpam.checkBoxForSpoofingDetection.unusualSignal'
            )}
          />
          <Popover placement="bottom" trigger="hover">
            <PopoverTrigger>
              <Icon as={InfoOIcon} color={colorStyle.color.secondary} />
            </PopoverTrigger>
            <PopoverContent py="4px" maxWidth="400px">
              <Text whiteSpace="pre-wrap">
                {t(
                  'policy.antiSpam.checkBoxForSpoofingDetection.unusualSignal.tooltip'
                )}
                {'\n'}
                <Link
                  href={getCasOLHLink(
                    CAS_DOC_LINK.policy.atp.unusualSignal,
                    i18next.language
                  )}
                  target="_blank"
                >
                  {t('common.action.label.learnMore')}
                </Link>
              </Text>
            </PopoverContent>
          </Popover>
        </Flex>
      </Stack>
    </Flex>
  );
};
export const AsNameSpoofing = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const asSpoofDetectEnabled = policySelector(
    (s) => s.tmAntispamfilters.asSpoofDetectEnabled
  );
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  const { iconColor, descriptionColor } = useAntiSpamRuleStyle();
  useWhyDidYouUpdate('AsNameSpoofing', { asSpoofDetectEnabled });
  return (
    <Flex direction="column" mt="24px">
      <Flex alignItems="center" mb="12px">
        <Switch
          checked={!!asSpoofDetectEnabled}
          value={asSpoofDetectEnabled}
          onChange={() => {
            // setAsSpoofDetectEnabled();
            setAsState({
              asSpoofDetectEnabled: asSpoofDetectEnabled === 1 ? 0 : 1,
            });
          }}
          size="sm"
        />
        <Text fontSize="16px" lineHeight="22px" ml="8px">
          {t('policy.detectionSettings.spamNameSpoofing')}
        </Text>
      </Flex>
      <Flex height="32px" alignItems="center">
        <Text color={descriptionColor}>
          {t('policy.detectionSettings.spamNameSpoofing.desc')}
        </Text>
        <Info
          iconStyle={{ color: iconColor, ml: '2x' }}
          content={t('policy.detectionSettings.spamNameSpoofing.desc.info')}
        />
      </Flex>
    </Flex>
  );
};

export const AsRetroScan = (props: {
  handleRetroScan: () => void;
  handleRetroScanModalClose: () => void;
}) => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const asRetroScanEnabled = policySelector(
    (s) => s.tmAntispamfilters.asRetroScanEnabled
  );
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  const { iconColor, descriptionColor } = useAntiSpamRuleStyle();
  const handleAsRetroScanEnabledChange = (e: any) => {
    props.handleRetroScan();
    setAsState({ asRetroScanEnabled: e.target.checked ? 1 : 0 });
  };
  useWhyDidYouUpdate('AsRetroScan', { asRetroScanEnabled });
  return (
    <Flex direction="column" mt="24px">
      <Flex alignItems="center" mb="12px">
        <Switch
          checked={!!asRetroScanEnabled}
          value={asRetroScanEnabled}
          onChange={handleAsRetroScanEnabledChange}
          size="sm"
        />
        <Text fontSize="16px" lineHeight="22px" ml="8px">
          {t('policy.detectionSettings.retroScanTitle')}
        </Text>
      </Flex>
      <Flex height="32px" alignItems="center">
        <Text color={descriptionColor}>
          {t('policy.detectionSettings.retroScanTitle.desc')}
        </Text>
        <Info
          iconStyle={{ color: iconColor, ml: '2x' }}
          content={t('policy.detectionSettings.retroScanTitle.desc.info')}
        />
      </Flex>
    </Flex>
  );
};
export const AsGrayMail = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const asGreyMailEnabled = policySelector(
    (s) => s.tmAntispamfilters.asGreyMailEnabled
  );
  const asGrayEmailMmlEnabled = policySelector(
    (s) => s.tmAntispamfilters.asGrayEmailMmlEnabled
  );
  const asGrayEmailSocialNetworkEnabled = policySelector(
    (s) => s.tmAntispamfilters.asGrayEmailSocialNetworkEnabled
  );
  const asGrayEmailForumEnabled = policySelector(
    (s) => s.tmAntispamfilters.asGrayEmailForumEnabled
  );
  const asGrayEmailBulkEnabled = policySelector(
    (s) => s.tmAntispamfilters.asGrayEmailBulkEnabled
  );
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  useWhyDidYouUpdate('AsGrayMail', {
    asGreyMailEnabled,
    asGrayEmailMmlEnabled,
    asGrayEmailSocialNetworkEnabled,
    asGrayEmailForumEnabled,
    asGrayEmailBulkEnabled,
  });
  return (
    <Flex mt="24px" direction="column">
      <Flex alignItems="center" mb="12px">
        <Switch
          checked={!!asGreyMailEnabled}
          value={asGreyMailEnabled}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            console.log('asGreyMailEnabled:', e.target.checked);
            setAsState({ asGreyMailEnabled: e.target.checked ? 1 : 0 });
          }}
          size="sm"
        />
        <Text fontSize="16px" lineHeight="22px" ml="8px">
          {t('policy.detectionSettings.graymail.sectionTitle')}
        </Text>
      </Flex>
      <Grid
        gap="1x"
        templateRows="32px 32px"
        templateColumns="300px 300px"
        ml="24px"
      >
        <Checkbox
          checked={!!asGrayEmailMmlEnabled}
          disabled={!asGreyMailEnabled}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            console.log('asGrayEmailMmlEnabled:', e.target.checked);
            setAsState({ asGrayEmailMmlEnabled: e.target.checked ? 1 : 0 });
          }}
          children={t(
            'policy.detectionSettings.graymail.checkBoxForMarketingMessage'
          )}
        />
        <Checkbox
          checked={!!asGrayEmailForumEnabled}
          disabled={!asGreyMailEnabled}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            console.log('asGrayEmailForumEnabled:', e.target.checked);
            setAsState({
              asGrayEmailForumEnabled: e.target.checked ? 1 : 0,
            });
          }}
          children={t(
            'policy.detectionSettings.graymail.checkBoxForForumNotification'
          )}
        />
        <Checkbox
          checked={!!asGrayEmailSocialNetworkEnabled}
          disabled={!asGreyMailEnabled}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            console.log('asGrayEmailSocialNetworkEnabled:', e.target.checked);
            setAsState({
              asGrayEmailSocialNetworkEnabled: e.target.checked ? 1 : 0,
            });
          }}
          children={t(
            'policy.detectionSettings.graymail.checkBoxForSocialNetwork'
          )}
        />
        <Checkbox
          checked={!!asGrayEmailBulkEnabled}
          disabled={!asGreyMailEnabled}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            console.log('asGrayEmailBulkEnabled:', e.target.checked);
            setAsState({
              asGrayEmailBulkEnabled: e.target.checked ? 1 : 0,
            });
          }}
          children={t('policy.detectionSettings.graymail.checkBoxForBulkEmail')}
        />
      </Grid>
    </Flex>
  );
};

export const WritingStyleAction = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  const policyMode = policySelector((s) => s.policyMode);
  // get state from store
  const wsEnabled = policySelector((s) => s.tmAntispamfilters.wsEnabled);
  const wsNotifyRecipientActionType = policySelector(
    (s) => s.tmAntispamfilters.wsNotifyRecipientActionType
  );
  const wsDisclaimer = policySelector((s) => s.tmAntispamfilters.wsDisclaimer);
  const wsSuspiciousTag = policySelector(
    (s) => s.tmAntispamfilters.wsSuspiciousTag
  );
  const policyType = policySelector((s) => s.policyType);
  const policySubType = policySelector((s) => s.policySubType);
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const gmailQtSettingFeatureShow =
    !!selectedOrgGlobalSetting?.gmailQtSettingFeatureShow;
  // local state
  const wsActionOptionsExchange = [
    ActionEnum.tagSubject,
    ActionEnum.delete,
    ActionEnum.quarantine,
    ActionEnum.moveToJunkEmailFolder,
    ActionEnum.addDisclaimer,
    ActionEnum.pass,
  ];
  const wsActionOptionsExchangeInline = [
    ActionEnum.tagSubject,
    ActionEnum.quarantine,
    ActionEnum.moveToJunkEmailFolder,
    ActionEnum.addDisclaimer,
    ActionEnum.pass,
  ];
  const wsActionOptionsGmail = gmailQtSettingFeatureShow
    ? [
        ActionEnum.labelEmail,
        ActionEnum.delete,
        ActionEnum.quarantine,
        ActionEnum.moveToSpam,
        ActionEnum.pass,
      ]
    : [
        ActionEnum.labelEmail,
        ActionEnum.delete,
        ActionEnum.moveToSpam,
        ActionEnum.pass,
      ];

  const wsActionOptionsGmailInlineInbound = [
    ActionEnum.tagSubject,
    ActionEnum.quarantine,
    ActionEnum.moveToSpam,
    ActionEnum.addDisclaimer,
    ActionEnum.pass,
  ];
  const actionOptions = React.useMemo(() => {
    let result: ActionEnum[] = [];
    switch (policyType) {
      case PolicyTypeEnum.Exchange:
        result = wsActionOptionsExchange;
        break;
      case PolicyTypeEnum.ExchangeInline:
        result = wsActionOptionsExchangeInline;
        break;
      case PolicyTypeEnum.Gmail:
        result = wsActionOptionsGmail;
        break;
      case PolicyTypeEnum.GmailInline:
        if (policySubType === PolicySubTypeEnum.inbound) {
          result = wsActionOptionsGmailInlineInbound;
        }
        break;
      default:
        break;
    }
    return result;
  }, [policyType]);

  useWhyDidYouUpdate('WritingStyleAction', {
    wsEnabled,
    wsNotifyRecipientActionType,
    wsDisclaimer,
    wsSuspiciousTag,
  });
  return (
    <>
      <Flex height="32px" alignItems="center">
        <FormLabel
          label={t('policy.detectionSettings.writingStyle.action')}
          width="50px"
          mr="12px"
        />
        <Select
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            console.log('wsNotifyRecipientActionType:', e.target.value);
            setAsState({
              wsNotifyRecipientActionType: Number(e.target.value),
            });
          }}
          width="206px"
          mr="12px"
          value={wsNotifyRecipientActionType}
          disabled={
            !wsEnabled || policyMode === PolicyModeEnum.DefaultMonitorPolicy
          }
        >
          {actionOptions.map((value: ActionEnum) => {
            return (
              <Option key={`writingStyle-action-${value}`} value={value}>
                {t(actionTranslateMap[value])}
              </Option>
            );
          })}
        </Select>
        {wsNotifyRecipientActionType === 5 && (
          <FormInput
            placeholder={t('policy.placeholder.subjectTag')}
            value={wsSuspiciousTag}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              console.log('wsSuspiciousTag:', e.target.value);
              setAsState({ wsSuspiciousTag: e.target.value });
            }}
            disabled={!wsEnabled}
            width="237px"
          />
        )}
      </Flex>
      {wsNotifyRecipientActionType === 209 && (
        <Flex mt="24px" ml="62px">
          <FormTextarea
            placeholder={t('policy.placeholder.addDisclaimer')}
            value={wsDisclaimer}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              console.log('wsDisclaimer:', e.target.value);
              setAsState({ wsDisclaimer: e.target.value });
            }}
            disabled={!wsEnabled}
          ></FormTextarea>
        </Flex>
      )}
    </>
  );
};
export const WritingStyleStatus = () => {
  const { widthReadablePermission } = usePermissionStore();
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const wsEnabled = policySelector((s) => s.tmAntispamfilters.wsEnabled);
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  const { descriptionColor } = useAntiSpamRuleStyle();
  useWhyDidYouUpdate('WritingStyleStatus', { wsEnabled });
  return (
    <>
      <Flex alignItems="center" mb="12px">
        <Switch
          checked={!!wsEnabled}
          value={wsEnabled}
          onChange={() => {
            // setWsEnabled();
            setAsState({ wsEnabled: wsEnabled === 1 ? 0 : 1 });
          }}
          size="sm"
        />
        <Text fontSize="16px" lineHeight="22px" ml="8px">
          {t('policy.detectionSettings.writingStyle.sectionTitle')}
        </Text>
      </Flex>

      <Flex height="32px" alignItems="center" mb="16px" whiteSpace="pre-wrap">
        <Trans
          i18nKey="policy.detectionSettings.writingStyle.desc"
          color={descriptionColor}
        >
          placeholder
          <RedirectLink
            disabled={
              !widthReadablePermission(PermissionNameEnum.administrator)
            }
            href={`policy/global-settings/high-profile-list`}
            target="_blank"
          >
            placeholder
          </RedirectLink>
        </Trans>
      </Flex>
    </>
  );
};
export const WsNotifySender = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const wsEnabled = policySelector((s) => s.tmAntispamfilters.wsEnabled);
  const wsNotifyExpectedSenderEnabled = policySelector(
    (s) => s.tmAntispamfilters.wsNotifyExpectedSenderEnabled
  );
  const wsNotifyExpectedSenderAttachOriginMailEnabled = policySelector(
    (s) => s.tmAntispamfilters.wsNotifyExpectedSenderAttachOriginMailEnabled
  );
  const wsNotifyExpectedSenderWithFeedbackEnabled = policySelector(
    (s) => s.tmAntispamfilters.wsNotifyExpectedSenderWithFeedbackEnabled
  );
  const wsNotifyRecipientActionType = policySelector(
    (s) => s.tmAntispamfilters.wsNotifyRecipientActionType
  );
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  // const isWsNotifyExpectedSenderEnabledIndeterminate = React.useMemo(() => {
  //   return (
  //     !wsNotifyExpectedSenderEnabled &&
  //     (wsNotifyExpectedSenderAttachOriginMailEnabled ||
  //       wsNotifyExpectedSenderWithFeedbackEnabled)
  //   );
  // }, [
  //   wsNotifyExpectedSenderEnabled,
  //   wsNotifyExpectedSenderAttachOriginMailEnabled,
  //   wsNotifyExpectedSenderWithFeedbackEnabled,
  // ]);
  useWhyDidYouUpdate('WsNotifySender', {
    wsEnabled,
    wsNotifyExpectedSenderEnabled,
    wsNotifyExpectedSenderAttachOriginMailEnabled,
    wsNotifyExpectedSenderWithFeedbackEnabled,
    setAsState,
    // isWsNotifyExpectedSenderEnabledIndeterminate,
  });
  return (
    <Flex direction="column" mt="24px">
      <Checkbox
        checked={!!wsNotifyExpectedSenderEnabled}
        disabled={!wsEnabled}
        // indeterminate={isWsNotifyExpectedSenderEnabledIndeterminate}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          console.log('wsNotifyExpectedSenderEnabled', e.target.checked);
          setAsState({
            wsNotifyExpectedSenderEnabled: e.target.checked ? 1 : 0,
          });
        }}
        children={t(
          'policy.detectionSettings.writingStyle.enableNotifyCompromisedSender'
        )}
      />
      <Stack direction="column" pl="6x" mt="2x" spacing="1x" shouldWrapChildren>
        <Checkbox
          checked={!!wsNotifyExpectedSenderAttachOriginMailEnabled}
          disabled={
            !wsNotifyExpectedSenderEnabled ||
            !wsEnabled ||
            wsNotifyRecipientActionType === ActionEnum.delete ||
            wsNotifyRecipientActionType === ActionEnum.quarantine
          }
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setAsState({
              wsNotifyExpectedSenderAttachOriginMailEnabled: e.target.checked
                ? 1
                : 0,
            });
          }}
          children={t(
            'policy.detectionSettings.writingStyle.enableNotifyCompromisedSender.originalEmail'
          )}
        />
        <Checkbox
          checked={!!wsNotifyExpectedSenderWithFeedbackEnabled}
          disabled={!wsNotifyExpectedSenderEnabled || !wsEnabled}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            console.log(
              'wsNotifyExpectedSenderWithFeedbackEnabled',
              e.target.checked
            );
            setAsState({
              wsNotifyExpectedSenderWithFeedbackEnabled: e.target.checked
                ? 1
                : 0,
            });
          }}
          children={t(
            'policy.detectionSettings.writingStyle.enableNotifyCompromisedSender.feedback'
          )}
        />
      </Stack>
    </Flex>
  );
};
export const WsNotifyAdmin = () => {
  const { widthEditablePermission } = usePermissionStore();
  const [isVisible, setIsVisible] = React.useState<boolean>(false);
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const wsEnabled = policySelector((s) => s.tmAntispamfilters.wsEnabled);
  const wsNotifyAdministratorEnabled = policySelector(
    (s) => s.tmAntispamfilters.wsNotifyAdministratorEnabled
  );
  const wsNotifyAdministratorAttachOriginMailEnabled = policySelector(
    (s) => s.tmAntispamfilters.wsNotifyAdministratorAttachOriginMailEnabled
  );
  const ntfWritingStyleToAdminAccount = policySelector(
    (s) => s.tmAntispamfilters.ntfWritingStyleToAdminAccount
  );
  const ntfWritingStyleAdministratorSubject = policySelector(
    (s) => s.tmAntispamfilters.ntfWritingStyleAdministratorSubject
  );
  const ntfWritingStyleAdministratorMessage = policySelector(
    (s) => s.tmAntispamfilters.ntfWritingStyleAdministratorMessage
  );
  const wsNotifyRecipientActionType = policySelector(
    (s) => s.tmAntispamfilters.wsNotifyRecipientActionType
  );
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  useWhyDidYouUpdate('WsNotifyAdmin', {
    isVisible,
    wsEnabled,
    wsNotifyAdministratorEnabled,
    wsNotifyAdministratorAttachOriginMailEnabled,
    ntfWritingStyleToAdminAccount,
    ntfWritingStyleAdministratorSubject,
    ntfWritingStyleAdministratorMessage,
    setAsState,
  });
  return (
    <>
      <Flex direction="column" mt="24px">
        <Flex alignItems="center" direction="row" height="20px">
          <Checkbox
            checked={!!wsNotifyAdministratorEnabled}
            // indeterminate={true}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              console.log('wsNotifyAdministratorEnabled', e.target.checked);
              setAsState({
                wsNotifyAdministratorEnabled: e.target.checked ? 1 : 0,
              });
            }}
            disabled={!wsEnabled}
            children={t(
              'policy.detectionSettings.writingStyle.enableNotifyAdmin'
            )}
          />
          <Icon
            as={EditIcon}
            size="16px"
            color={
              !wsNotifyAdministratorEnabled || !wsEnabled
                ? colorStyle.color.disabled
                : colorStyle.color.info
            }
            ml="24px"
          />
          <Button
            variant="ghost"
            color={colorStyle.color.info}
            onClick={() => {
              setIsVisible((isVisible: Boolean) => {
                return !isVisible;
              });
            }}
            disabled={
              !wsNotifyAdministratorEnabled ||
              !wsEnabled ||
              !widthEditablePermission(PermissionNameEnum.atpPolicy)
            }
          >
            {t('policy.detectionSettings.writingStyle.editMailTemplateModal')}
          </Button>
        </Flex>
        <Stack
          direction="column"
          pl="6x"
          mt="2x"
          spacing="1x"
          shouldWrapChildren
        >
          <Checkbox
            checked={!!wsNotifyAdministratorAttachOriginMailEnabled}
            disabled={
              !wsNotifyAdministratorEnabled ||
              !wsEnabled ||
              wsNotifyRecipientActionType === ActionEnum.delete ||
              wsNotifyRecipientActionType === ActionEnum.quarantine
            }
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setAsState({
                wsNotifyAdministratorAttachOriginMailEnabled: e.target.checked
                  ? 1
                  : 0,
              });
            }}
            children={t(
              'policy.detectionSettings.writingStyle.enableNotifyAdmin.originalEmail'
            )}
          />
        </Stack>
      </Flex>
      <EditNotificationModal
        isVisible={isVisible}
        onClose={() => setIsVisible(false)}
        config={{
          ntfWritingStyleToAdminAccount,
          ntfWritingStyleAdministratorSubject,
          ntfWritingStyleAdministratorMessage,
        }}
        saveConfig={(config: {
          ntfWritingStyleToAdminAccount: string;
          ntfWritingStyleAdministratorSubject: string;
          ntfWritingStyleAdministratorMessage: string;
        }) => {
          console.log('modal config:', config);
          const {
            ntfWritingStyleToAdminAccount,
            ntfWritingStyleAdministratorSubject,
            ntfWritingStyleAdministratorMessage,
          } = config;
          setAsState({
            ntfWritingStyleToAdminAccount,
            ntfWritingStyleAdministratorSubject,
            ntfWritingStyleAdministratorMessage,
          });
        }}
      />
    </>
  );
};
export const AsWritingStyle = () => {
  return (
    <Flex direction="column" mt="24px">
      <WritingStyleStatus />
      <WritingStyleAction />
      <WsNotifySender />
      <WsNotifyAdmin />
    </Flex>
  );
};
export const AsDetectionTechnique = (props: {
  asSuspiciousDetectionShow: boolean;
  asRetroScanShow: boolean;
  asGrayMailShow?: boolean;
  asWritingStyleShow?: boolean;
  handleRetroScan: () => void;
  handleRetroScanModalClose: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <TitleLabel title={t('policy.detectionSettings.title')} />
      <AsBec />
      {props.asSuspiciousDetectionShow ? <AsSuspiciousDetection /> : null}
      <AsNameSpoofing />
      {props.asRetroScanShow ? (
        <AsRetroScan
          handleRetroScan={props.handleRetroScan}
          handleRetroScanModalClose={props.handleRetroScanModalClose}
        />
      ) : null}
      {props.asGrayMailShow ? <AsGrayMail /> : null}
      {props.asWritingStyleShow ? <AsWritingStyle /> : null}
    </>
  );
};

const Rules = ({
  applyBoundShow = true,
  asDetectionTechniqueShow = true,
  asSuspiciousDetectionShow = true,
  asRetroScanShow = true,
  asGrayMailShow = true,
  asWritingStyleShow = true,
}: {
  applyBoundShow?: boolean;
  asDetectionTechniqueShow?: boolean;
  asSuspiciousDetectionShow?: boolean;
  asRetroScanShow?: boolean;
  asGrayMailShow?: boolean;
  asWritingStyleShow?: boolean;
}) => {
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state from store
  const asRetroScanEnabled = policySelector(
    (s) => s.tmAntispamfilters.asRetroScanEnabled
  );
  // get action from store
  const setAsState = contextSelector((s) => s.setAsState);
  console.log('render rules');
  const [retroScanModal, setRetroScanModal] = React.useState<boolean>(false);
  const handleRetroScan = () => {
    if (asRetroScanEnabled === 0) {
      setRetroScanModal(true);
    }
    return;
  };
  const handleRetroScanModalClose = () => {
    setAsState({ asRetroScanEnabled: asRetroScanEnabled === 1 ? 0 : 1 });
    setRetroScanModal(false);
  };

  const onConfirm = () => {
    setRetroScanModal(false);
  };

  return (
    <div>
      <Box ml="1px" mt="16px">
        <AsRuleStatus />
        <Divider mt="10px" mb="10px" />
        {applyBoundShow ? <AsApplyBound /> : null}
        <AsDetectionLevel />
        <Divider mt="32px" mb="32px" />
        {asDetectionTechniqueShow ? (
          <AsDetectionTechnique
            asSuspiciousDetectionShow={asSuspiciousDetectionShow}
            asRetroScanShow={asRetroScanShow}
            asGrayMailShow={asGrayMailShow}
            asWritingStyleShow={asWritingStyleShow}
            handleRetroScan={handleRetroScan}
            handleRetroScanModalClose={handleRetroScanModalClose}
          />
        ) : null}
        <RetroScanEnableModal
          isVisible={retroScanModal}
          onClose={handleRetroScanModalClose}
          onConfirm={onConfirm}
          filterType="advancedSpamProtection"
        />
      </Box>
    </div>
  );
};
export default React.memo(Rules);
